exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container[data-v-32650bfb] {\n  padding: 20px;\n}\n.container .bill-check-content[data-v-32650bfb] {\n  background-color: #fff;\n  border-radius: 4px;\n}\n.container .bill-check-content .el-tabs[data-v-32650bfb] {\n  padding: 20px 0;\n}\n", ""]);

